import DataSourceController from '@/views/fusion/investment/intelligence-create/controller/DataSourceController';
import store from '@/store';
import { transformTreeKey } from '@/tools/form';
import { getDeliveryContentApi } from '@/api/tool/delivery-content';
import { getConvertGoalListApi } from '@/api/tool/convert-goal';
import { getDeepConvertGoalApi } from '@/api/tool/deep-convert-goal';
import { getDeepBidTypeApi } from '@/api/tool/deep-bid-type';
import { getBrandListApi, getBrandCategoryListApi } from '@/api/tool/brand';

/**
 * 管理头条渠道的数据
 */
export default class JrttDataSourceController extends DataSourceController {
  /**
   * 获取投放内容
   * @param {Object} filtering 渠道过滤条件
   * @returns {Promise<Object[]>}
   */
  async getDeliveryContentById(advertiser_id, filtering = {}) {
    try {
      const channel_interface = this.getChannelInterfaceEnum();
      const params = {
        channel_interface,
        advertiser_id,
        filtering,
      };
      const ret = await getDeliveryContentApi(params);
      const result = (ret?.list || []).map(({ id, name, ...rest }) => ({ label: `${name}（${id}）`, value: `${id}#${name}`, ...rest }));
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取优化目标列表
   * @param {Object} filtering 渠道过滤条件
   * @returns {Promise<Object[]>}
   */
  async getConvertGoalList(filtering = {}) {
    try {
      const params = {
        channel_interface: this.getChannelInterfaceEnum(),
        advertiser_id: this.getRequestAdvertiser(),
        ...filtering,
      };
      const ret = await getConvertGoalListApi(params);
      const result = (ret?.list || []).map(({ id, name }) => ({ label: name, value: id }));
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取深度优化目标列表
   * @param {Object} filtering 渠道过滤条件
   * @returns {Promise<Object[]>}
   */
  async getDeepConvertGoalList(filtering = {}) {
    try {
      const params = {
        channel_interface: this.getChannelInterfaceEnum(),
        advertiser_id: this.getRequestAdvertiser(),
        ...filtering,
      };
      const ret = await getDeepConvertGoalApi(params);
      const result = (ret?.list || []).map(({ id, name }) => ({ label: name, value: id }));
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取深度优化方式
   * @param {Object} filtering 渠道过滤条件
   * @returns {Promise<Object[]>}
   */
  async getDeepBidTypeList(filtering = {}) {
    try {
      const params = {
        channel_interface: this.getChannelInterfaceEnum(),
        advertiser_id: this.getRequestAdvertiser(),
        ...filtering,
      };
      const ret = await getDeepBidTypeApi(params);
      const result = (ret?.list || []).map(({ id, name }) => ({ label: name, value: id }));
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取穿山甲视频创意类型枚举
   * @returns {Promise<Object[]>}
   */
  async getUnionVideoTypeEnums() {
    try {
      const channel_interface = this.getChannelInterfaceEnum();
      const data = channel_interface ? store.getters[`${channel_interface}Enum`].api_fusion_union_video_type : [];
      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取品牌名称列表
   * @returns {Promise<Object[]>}
   */
  async getBrandList() {
    try {
      const params = {
        channel_interface: this.getChannelInterfaceEnum(),
        advertiser_id: this.getRequestAdvertiser(),
      };
      const ret = await getBrandListApi(params);
      const result = (ret?.list || []).map(({ id, name }) => ({ label: name, value: `${id}#${name}` }));
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  /**
   * 获取所属类别列表
   * @returns {Promise<Object[]>}
   */
  async getBrandCategoryList() {
    try {
      const params = {
        channel_interface: this.getChannelInterfaceEnum(),
        advertiser_id: this.getRequestAdvertiser(),
      };
      const ret = await getBrandCategoryListApi(params);
      const result = transformTreeKey({ options: ret?.list || [], value_key: 'id' });
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
